import moment from 'moment';
import React, { useEffect, useState } from 'react'
import ReactDatePicker from 'react-datepicker';
import { Col, Label, Progress, Row } from 'reactstrap';
import { CalenderIcon } from '../../../Icon';
import { RedDeleteIcon } from '../../../../assets/images';
import "../../../Scheduling/index.scss"
type AppProps = {
  previousHours: any;
  oneTimeEstimateDataInput: any;
  oneTimeEstimateData: any;
  handleDateChange: (data: any, data1: any, data2: any) => void;
  handleHoursChange: (data: any, data1: any, data3: any, date: string) => void;
  handleRemoveRow: (data: any) => void;
  hasError: any
  dispatchResetPrevoiusHour: () => void;
  showSchedulingEstimateData: any;
  disableDate: any;
}
const OneTimeEstimateInput = ({
  previousHours,
  oneTimeEstimateData,
  handleDateChange,
  handleHoursChange,
  oneTimeEstimateDataInput,
  handleRemoveRow,
  dispatchResetPrevoiusHour,
  hasError,
  showSchedulingEstimateData,
  disableDate
}: AppProps) => {
  const [index, setIndex] = useState<any>(null)
  const [item, setItem] = useState({})
  const [data, setData] = useState<any>(JSON.parse(JSON.stringify(oneTimeEstimateData)))
  let todaysDate = moment().format("YYYY-MM-DD");

  useEffect(() => {
    let arr: any[] = []
    oneTimeEstimateData?.map((item: any, i: number) => {
      arr.push({ ...item })
    })
    setData([...arr])
  }, [oneTimeEstimateData])
  useEffect(() => {
    if (index != null) {
      if (!!data && data.length && !!data[index] && previousHours) {
        fillProgress(data[index], index)
      }
    }

  }, [previousHours, index])

  const fillProgress = (item: any, i: any) => {
    if (i === index && previousHours) {

      item["previoushours"] = previousHours


      if (previousHours > 12) {
        item["errorMessage"] = "Error! Maximum hours for the day exceeded"
      }
      else {
        item["errorMessage"] = ""
      }
    }
    item["date"] = item?.date
    item["hours"] = item?.hours
    oneTimeEstimateData[index] = { ...item }
    setData([...oneTimeEstimateData])
    // dispatchResetPrevoiusHour()
  }

  const renderRecurringschedulingInput = () => {
    let arr: any[] = [];
    data.map((item: any, i: number) => {
      arr.push(
        <tr>
          <td>
            <Row style={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}>
              <Col style={{ maxWidth: "220px" }}>
                <div className="date-picker-wraper">
                  <Label className="m-0 p-0 w-100">
                    <ReactDatePicker
                      dateFormat="EEE, dd-MM-yyyy"
                      selected={
                        item?.date
                          ? new Date(
                            moment(
                              `${item?.date}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                          : null
                      }
                      onChange={(e: any) => {
                        if (!!e) {
                          handleDateChange?.(
                            moment(e).format("YYYY-MM-DD"),
                            i,
                            "date"
                          );
                        }
                        setItem(item)
                        setIndex(i)

                      }}
                      disabled={!!item?.date && (item?.date < todaysDate)}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      minDate={moment(new Date()).add(1, "days").toDate()}
                      name="dateOfInvoice"
                      placeholderText="Choose Date"
                      className="form-control"
                      excludeDates={disableDate}
                    />
                    <span
                      className="calender-icon"
                      style={{
                        cursor: "pointer",
                        top: "7px",
                        right: '30px',
                      }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>

                </div>

              </Col>
              <div style={{ width: "315px", display: "flex", justifyContent: "center" }}>
                <input
                  type="number"
                  value={item?.hours ? item.hours : ""}
                  disabled={!!item?.date && (item?.date < todaysDate)}
                  max="12"
                  onWheel={(event) => event.currentTarget.blur()}
                  onChange={(e: any) => {
                    handleHoursChange?.(e.target.value, i, "hours", item?.date)
                  }}
                  onKeyPress={(e) => {
                    if (e.key === '+' || e.key === '-') {
                      e.preventDefault();
                    }
                  }}
                  className="form-control "
                  style={{ width: "22%", marginLeft: "1px" }}
                />
                {hasError && <span style={{ color: 'red' }}>Total cannot be more than 12</span>}
                {oneTimeEstimateData?.length > 1 ? <Col
                  className="d-flex align-items-sm-center mr-1 p-2" xs={1}

                >

                  {(!!item?.date && item?.date < todaysDate) ? null :
                    <img
                      className="pointer"
                      onClick={() => handleRemoveRow(i)}
                      style={{}}
                      src={RedDeleteIcon}
                      alt={"remove"}
                    />
                  }
                </Col> : ''}
              </div>

              <div style={{ flexGrow: "1", maxWidth: "400px" }}>

                <div className='d-flex'>
                  <Progress
                    striped
                    style={{ height: "15px", marginRight: "10px", width: "100%", backgroundColor: "#bfcbe1" }}
                    value={item?.progressCount}
                    max={12}
                    color={item?.progressCount >= 12 ? "warning" : "success"}

                  >
                  </Progress>
                  <span style={{ marginRight: "10px" }}>{item?.progressCount ? item?.progressCount : 0}/12</span>
                </div>

                <div style={{ color: "red", fontSize: "10px" }}>
                  {item?.errorMessage ?
                    item?.errorMessage
                    : null}
                </div>


              </div>



            </Row>
          </td>
        </tr>
      )
    });
    return arr;
  }

  return (
    <>
      {renderRecurringschedulingInput()}

    </>
  )
}

export default OneTimeEstimateInput
